

// remover data locastorage
export const clearStorage = () =>{
    localStorage.removeItem('stepz');
    localStorage.removeItem('pagar');
}


export const setItemStepz = (item) => {
    const itemStepz = JSON.stringify({ ...JSON.parse(localStorage.getItem('stepz')), ...item })
    localStorage.setItem('stepz', itemStepz);
}

export const getItemStepz = () => {
    const itemStepz = JSON.parse(localStorage.getItem('stepz')) || null;
    return itemStepz;
}

export const setStoragePersist = (key, data) => {
    const datos = JSON.stringify(data);
    localStorage.setItem(key, datos);
}

// setear datos
export const setStoragePersistPagar = (data) => {

    // datos anteriores
    const previousData = JSON.parse(localStorage.getItem('pagar')) || [];

    // concatenar datos anteriores y actuales
    const currentData = data.concat(previousData);

    // set data
    localStorage.setItem('pagar', JSON.stringify(currentData));
}

// remove data por id
export const removeStoragePersistPagarById = (id) => {

    // datos anteriores
    const previousData = JSON.parse(localStorage.getItem('pagar')) || [];

    // concatenar datos anteriores y actuales
    const currentData = previousData.filter(values => values.ID !== id);

    // set data
    localStorage.setItem('pagar', JSON.stringify(currentData));
}

// set all data persist
export const setStoragePersistPagarAll = (data) => {
    localStorage.setItem('pagar', JSON.stringify(data));
}

// remove all persist all
export const removeStoragePersistPagarAll = () => {
    localStorage.setItem('pagar', JSON.stringify([]));
}

// set pagar
export const setStoragePersistMontoPagar = (pago, id) => {

    // console.log(pago)
    // datos anteriores
    const currentData = JSON.parse(localStorage.getItem('pagar')) || [];

    // const filterData = currentData.filter(values => values?.ID === id);
    // console.log(currentData);

    const nuevoData = currentData.map(values => {

        let object = { ...values };
        if (values.ID == id) {
            object = { ...object, PAGAR: pago }
        }

        return object
    });

    localStorage.setItem('pagar', JSON.stringify(nuevoData));
}
